import { render } from "./PaidQuestions.vue?vue&type=template&id=de140fdc&scoped=true"
import script from "./PaidQuestions.vue?vue&type=script&lang=js"
export * from "./PaidQuestions.vue?vue&type=script&lang=js"

import "./PaidQuestions.vue?vue&type=style&index=0&id=de140fdc&scoped=true&lang=css"

import exportComponent from "/Users/bytedance/New/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de140fdc"]])

export default __exports__